// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__BdqHV","col":"styles_col__3rzXa","fulfillmentStatus":"styles_fulfillmentStatus__1isC-","emailCol":"styles_emailCol__1vkW3"};